import axios from 'axios'
import config from '@/config'
import store from '@/store'
import router from '@/router'
import errors from './errors'

let callCount = 0
export function beginLoading() {
  callCount += 1
  if (callCount === 1) {
    store.dispatch('spinner/showModal')
  }
}
export function endLoading() {
  callCount -= 1
  if (callCount === 0) {
    store.dispatch('spinner/hideModal')
  }
}

export function callApi(path, params, method) {
  return new Promise((resolve, reject) => {
    const isGet = !method || method === 'get'
    const options = {
      method: method || 'get',
      url: `${config.api.baseUri}/${path}`,
      params: isGet ? params || {} : undefined,
      data: !isGet ? params || {} : undefined,
      withCredentials: true,
    }

    beginLoading()

    axios(options)
      .then((res) => {
        endLoading()

        if (res.status !== errors.STATUS_OK) {
          return reject(res.status)
        }

        if (res.data && res.data.errorCode === errors.LOGIN_REQUIRED) {
          window.$cookies.set('__redirect', document.location.href)
          window.$cookies.set('isLoggedIn', false)
          return router.push('/login')
        }

        if (res.data && res.data.errorCode) {
          let content = res.data.errorCode
          if (res.data.errorData) content += `<br>${res.data.errorData}`
          store.dispatch('dialog/showAlert', content)
          return 0
        }

        return resolve(res.data)
      })
      .catch((err) => {
        endLoading()

        if (err.response) return reject(err.response.status)

        return reject(err.message)
      })
  })
}

export function basicApi(path) {
  return {
    list: (params) => callApi(path, params || {}),
    get: (id) => callApi(`${path}/${id}`),
    add: (params) => callApi(`${path}`, params, 'post'),
    modify: (id, params) => callApi(`${path}/${id}`, params, 'put'),
    patch: (id, params) => callApi(`${path}/${id}`, params, 'patch'),
    remove: (id) => callApi(`${path}/${id}`, {}, 'delete'),
  }
}

export default {
  callApi,
  basicApi,
  beginLoading,
  endLoading,
}
